import { Breadcrumb } from 'rsuite';
import styled from 'styled-components';

const StyledBreadcrumb = styled(Breadcrumb)`
  margin-bottom: 0;
  padding: 8px 0;
`;

export default StyledBreadcrumb;
